import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { manageFootballTeamService } from "../../../../../../../commons";
import { StatusEnum } from "../../../../../../../commons/enums/status-enum";

export interface IManageSubTeamCoachAddState {
  manageSubTeamCoachAddStatus: StatusEnum;
}

export interface IManageSubTeamCoachAddOption {
  teamId: number;
  subTeamId: number;
  userId: number;
}

const initialState: IManageSubTeamCoachAddState = {
  manageSubTeamCoachAddStatus: StatusEnum.Idle,
};

export const subTeamCoachAdd = createAsyncThunk(
  "manage/subTeamCoachAdd",
  async (options: IManageSubTeamCoachAddOption, thunkAPI) => {
    try {
      const manageSubTeamCoachAdd = await manageFootballTeamService.addSubTeamCoach(
        options.teamId,
        options.subTeamId,
        options.userId
      );
      return manageSubTeamCoachAdd;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const manageSubTeamCoachAddSlice = createSlice({
  name: "manageSubTeamCoachAddSlice",
  initialState: initialState,
  reducers: {
    cleanUpSubTeamCoachAdd(state) {
      state.manageSubTeamCoachAddStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(subTeamCoachAdd.pending, (state) => {
        state.manageSubTeamCoachAddStatus = StatusEnum.Loading;
      })
      .addCase(subTeamCoachAdd.fulfilled, (state) => {
        state.manageSubTeamCoachAddStatus = StatusEnum.Succeeded;
      })
      .addCase(subTeamCoachAdd.rejected, (state) => {
        state.manageSubTeamCoachAddStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpSubTeamCoachAdd } = manageSubTeamCoachAddSlice.actions;
export default manageSubTeamCoachAddSlice.reducer;
